import { createFileRoute } from "@tanstack/react-router";
import { EmployeeFeedbackView } from "@/components/employee/EmployeeFeedbackView";

export const Route = createFileRoute("/_authenticated/employee/feedback")({
  head: () => ({ meta: [{ title: "Submit Feedback — Staff" }] }),
  component: EmployeeFeedbackPage,
});

function EmployeeFeedbackPage() {
  return <EmployeeFeedbackView />;
}
